<template>
  <rmr-page-hero
    title="Création d'articles"
    title-accent="à partir de sources"
    subtitle="Sélectionnez les sources les plus pertinentes pour lancer une rédaction IA"
    :icon="icons.mdiRssBox"
  >
    <template #actions>
      <div class="pbs-hero__actions">
        <rmr-segmented-control
          :value="activeTab"
          :items="tabItems"
          variant="on-dark"
          @input="$emit('update:activeTab', $event)"
        />
        <dag-info :dags="dags" class="pbs-hero__dag-info" />
      </div>
    </template>
  </rmr-page-hero>
</template>

<script>
import { mdiRssBox } from "@mdi/js";

import DagInfo from "@/components/common/menus/DagInfo";
import RmrPageHero from "@/components/ui/layout/RmrPageHero.vue";
import RmrSegmentedControl from "@/components/ui/actions/RmrSegmentedControl.vue";
import { NEWS_RADAR_CRAWLER_DAGS } from "@/utils/constants";

export const TAB_GLOBAL_WATCH = "veille";
export const TAB_URL_BATCH = "urls";

export default {
  name: "PostBySourcesHero",
  components: {
    DagInfo,
    RmrPageHero,
    RmrSegmentedControl,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
      validator: (value) => [TAB_GLOBAL_WATCH, TAB_URL_BATCH].includes(value),
    },
    dags: {
      type: Array,
      default: () => NEWS_RADAR_CRAWLER_DAGS,
    },
  },
  setup() {
    return {
      icons: { mdiRssBox },
      tabItems: [
        { value: TAB_GLOBAL_WATCH, label: "VEILLE GLOBALE" },
        { value: TAB_URL_BATCH, label: "LOT D'URLS" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.pbs-hero__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

// DagInfo renders a dark tooltip icon by default, unreadable on the hero gradient.
.pbs-hero__dag-info ::v-deep .tooltip-info {
  color: rgba(255, 255, 255, 0.75) !important;
}
</style>
